import { useTranslation } from "react-i18next";
import { Box, Stack, styled, Typography } from "@mui/material";
import React from "react";
import Grid2 from "@mui/material/Unstable_Grid2";

const Title = styled(Typography)(({ theme }) => ({
  fontSize: "1.8rem",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "120%",
  letterSpacing: "-0.5px",
  color: "#002B23",
}));

interface StepsDescriptionViewProps {
  stepName: string;
  name?: string;
}

const logos = [
  {
    name: "v2-nordnet-logo-greenwash",
    alt: "Nordnet",
  },
  { name: "v2-seb-logo-greenwash", alt: "SEB" },
  { name: "v2-qred-logo-greenwash", alt: "Qred" },
  {
    name: "v2-soderberg-logo-greenwash",
    alt: "Söderberg & Partners",
  },
  {
    name: "v2-fortnox-logo-greenwash",
    alt: "Fortnox",
  },
  { name: "v2-dnb-logo-greenwashed", alt: "DNB" },
];

const StepsDescriptionView = ({
  stepName,
  name,
}: StepsDescriptionViewProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Stack component="hgroup">
        {stepName === "PaymentMethod" ||
        stepName === "RegistrationConfirmation" ? (
          <Title>{t("step.finalize.description.title", { name: name })}</Title>
        ) : (
          <Title>{t(`step.${stepName}.description.title`)}</Title>
        )}
        <Typography
          sx={{
            lineHeight: "1.8",
          }}
          dangerouslySetInnerHTML={{
            __html: t(`step.${stepName}.description.text`),
          }}
        />
      </Stack>
      <Grid2
        container
        justifyContent="center"
        alignItems="center"
        spacing={4}
        mt={4}
        pl={0}
      >
        {stepName === "ContactDetails" &&
          logos.map((logo) => (
            <Grid2
              key={logo.alt}
              xs={6}
              md={6}
              lg={4}
              textAlign="center"
              display="flex"
              justifyContent="center"
            >
              <Box
                component="img"
                src={`https://assets.roaring.io/svg/onboarding/${logo.name}.svg`}
                alt={logo.alt}
                sx={{
                  width: "clamp(180px, 15vw, 225px)",
                  height: 130,
                }}
              />
            </Grid2>
          ))}
      </Grid2>
    </>
  );
};

export default StepsDescriptionView;
